import { images } from "../../../../../Media";
import { Globals } from "../../../logic/services/Globals";
import CardWrapper from "../../components/wrapper/card/CardWrapper";
import AppCSSService from "../../services/AppCSSService";
import { IDeviceStateControllerReturn } from "../../../../../commonreact/main/services/devicestate/DeviceStateController";
import { ELng } from "../../../../../language/main/LanguageKeysEnums";
import { useTranslation } from "react-i18next";

interface IProps {
  dsc: IDeviceStateControllerReturn;
}


const AboutUs = (props: IProps): JSX.Element => {

  const { t } = useTranslation();
  const imageWidth = 300;
  const videoWidth = 450;
  return (
    <div className={`${AppCSSService.cardsWrapper} ${!props.dsc.small ? "w-4/5" : "w-full"} mt-4`}>

      {/* <CardWrapper
      dsc={props.dsc}
      header={<>What it is</>}
    >
      <div className="flex flex-col">
        <div className="flex flex-row">
          <div className={`w-6/12`}>
            <p>
              Learn to improvise over common chord progressions, while the app displays the harmonical context your are in.
            </p>
            <br></br>
            <p>
              Wheel of Harmonies is a compact music theory learning tool based on the Circle of Fifths.
            </p>
          </div>
          <div className={`w-6/12`}>
            <video width={videoWidth} className={`rounded-lg `} autoPlay muted controls >
              <source src={Globals.assetsFolder + "/videos/promo.mp4"} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </CardWrapper> */}

      {/* <CardWrapper
      dsc={props.dsc}
        header={<>Versions</>}
      >
        <div className="flex flex-col">

          <div className={`w-full`}>
            <p>
              There a two version that work slightly different.
            </p>
          </div>

          <div className={`flex flex-row`}>
            <div className={`w-6/12`}>
              <p> Android App </p>
              <div className={`p-2`}>
                <img className={"rounded-lg"}
                  src={images.app0}
                  width={imageWidth}
                />
              </div>
            </div>

            <div className={`w-6/12`}>
              <p> Website </p>
              <div className={`p-2`}>
                <img className={"rounded-lg"}
                  src={images.webv11}
                  width={imageWidth}
                />
              </div>
            </div>
          </div>
        </div>
    </CardWrapper> */}

      <CardWrapper
        header={<h1>{t(ELng._ABOUT_US.valueOf())}</h1>}
        dsc={props.dsc}
        addClassName={"mb-40"}
      >

        <section>
          <p className="w-4/5 p-2">
            {t(ELng.about_us_0.valueOf())}
          </p>
        </section>

        <section className="mt-5">
          <div className={`p-2 flex ${props.dsc.tiny?"flex-col":"flex-row"} cursor-pointer rounded-lg ${AppCSSService.onItemHover1}`}
            onClick={() => {
              window.open(Globals.webJens, "blank")
            }}
          >
            <img className={"w-[10rem] h-[7.5rem] rounded-xl"} src={images.jens} />
            <p className={`w-4/5 ${props.dsc.tiny?"pl-0 w-full":"pl-4 w-4/5"} `}>
              {t(ELng.about_us_jens.valueOf())}
            </p>
          </div>
        </section>


        <section className="mt-5 ">
          <div className={`p-2 flex ${props.dsc.tiny?"flex-col":"flex-row"} cursor-pointer rounded-lg ${AppCSSService.onItemHover1}`}
            onClick={() => {
              window.open(Globals.webJan, "blank")
            }}
          >
            <p className={`${props.dsc.tiny?"pl-0 w-full":"pl-4 w-4/5"} `}>
              {t(ELng.about_us_jan.valueOf())}
            </p>
            <img className={"w-[10rem] h-[7.5rem] rounded-xl"} src={images.jan} />
          </div>
        </section>
      </CardWrapper>
    </div>
  );
}

export default AboutUs;
